import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const inventoryApi = createApi({
  reducerPath: "inventoryApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["Items", "CampusStockAllotments"],
  endpoints: (builder) => ({
    getCentralInventory: builder.query({
      query: ({ page = 1, limit = 10, search = "", category = "" }) => {
        const params = { page, limit };
        if (search) params.search = search;
        if (category) params.category = category;
        return {
          url: "/centralinventory",
          method: "GET",
          params,
        };
      },
      providesTags: ["Items"],
    }),
    getCentralInventoryById: builder.query({
      query: (id) => ({
        url: `/centralinventory/${id}`,
        method: "GET",
      }),
      providesTags: ["Items"],
    }),
    getCentralInventoryCampusSide: builder.query({
      query: () => ({
        url: "/centralinventory/campusside",
        method: "GET",
      }),
      providesTags: ["Items"],
    }),
    createCentralInventory: builder.mutation({
      query: (payload) => ({
        url: "/centralinventory",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Items"],
    }),
    adjustCentralInventoryStock: builder.mutation({
      query: ({ id, action, amount }) => ({
        url: `/centralinventory/${id}`,
        method: "PATCH",
        body: { action, amount },
      }),
      invalidatesTags: ["Items"],
    }),
    getCampusInventory: builder.query({
      query: ({ campusId, page = 1, limit = 10, search = "", category = "", fromDate = "", toDate = "" }) => {
        const params = {
          ...(search && { search }),
          ...(category ? { category } : {}),
          ...(fromDate && { fromDate }),
          ...(toDate && { toDate }),
        };
        if (limit && limit !== "All") {
          params.page = page;
          params.limit = limit;
        }
        return {
          url: `/campusinventory/admin/${campusId}`,
          method: "GET",
          params,
        };
      },
    }),
    getCampusSideInventory: builder.query({
      query: ({ campusId, page = 1, limit = 10, search = "", category = "", fromDate = "", toDate = "" }) => {
        const params = {
          ...(search && { search }),
          ...(category ? { category } : {}),
          ...(fromDate && { fromDate }),
          ...(toDate && { toDate }),
        };
        if (limit && limit !== "All") {
          params.page = page;
          params.limit = limit;
        }
        return {
          url: `/campusinventory/campus/${campusId}`,
          method: "GET",
          params,
        };
      },
      providesTags: ["Items"],
    }),
    allotItemToCampus: builder.mutation({
      query: (payload) => ({
        url: "/campusinventory/allot",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["CampusStockAllotments"],
    }),
    getCentralLowStock: builder.query({
      query: (params) => ({
        url: "/centralinventory/lowstock",
        method: "GET",
        params,
      }),
    }),
    getCampusLowStock: builder.query({
      query: ({ campusId, ...params }) => ({
        url: `/campusinventory/campus/${campusId}/lowstock`,
        method: "GET",
        params,
      }),
    }),
    getAdminCampusLowStock: builder.query({
      query: ({ campusId, ...params }) => ({
        url: `/campusinventory/admin/${campusId}/lowstock`,
        method: "GET",
        params,
      }),
    }),
  }),
});

export const {
  useGetCentralInventoryQuery,
  useGetCentralInventoryByIdQuery,
  useGetCentralInventoryCampusSideQuery,
  useCreateCentralInventoryMutation,
  useAdjustCentralInventoryStockMutation,
  useGetCampusInventoryQuery,
  useGetCampusSideInventoryQuery,
  useAllotItemToCampusMutation,
  useGetCentralLowStockQuery,
  useLazyGetCentralLowStockQuery,
  useGetCampusLowStockQuery,
  useLazyGetCampusLowStockQuery,
  useGetAdminCampusLowStockQuery,
  useLazyGetAdminCampusLowStockQuery,
} = inventoryApi;
